import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

import { useCreatePetitionUpdateContext } from '../../../../../../context';

function AdditionalCtaButton(): JSX.Element | null {
	return (
		<Button
			size="small"
			variant="primary"
			className="w-full"
			aria-disabled
			tabIndex={-1}
			data-qa="additional-cta-button"
		>
			<Translate value="corgi.petition_update.preview_modal.share_ask_cta" />
		</Button>
	);
}

export function PreviewEmailCtaButtons(): JSX.Element {
	const useIsTemplateFilled = useCreatePetitionUpdateContext();

	return (
		<div className="px-4">
			<Button
				size="small"
				variant="primary"
				className={cn('w-full', { 'mb-2': useIsTemplateFilled })}
				aria-disabled
				tabIndex={-1}
				data-qa="preview-email-cta-button"
			>
				<Translate value="corgi.petition_update.preview_modal.update_cta" />
			</Button>
			{useIsTemplateFilled && <AdditionalCtaButton />}
		</div>
	);
}
